<template>
    <div>
        <!-- Tiêu đề -->
        <div class="flex-tt">
            <h2 class="td-tt">{{ $t("manage_lesson.static") }}</h2>
        </div>

        <div v-if="results.length == 0 && !first">
            <div class="nameTestExam">
                <span>{{ $t("scoreStaticNew.noInformation") }}</span>
            </div>
        </div>

        <!-- Danh sách lịch sử thi cuối kì -->
        <template v-for="(item, index) in results">
            <div :key="index">
                <!-- Tên kì thi -->
                <div class="nameTestExam">
                    <span>{{ $t("scoreStatistics.testName") }}: </span>
                    <span>{{item.examId == null ? $t("scoreStatistics.finalExam") : item.examName }}</span>
                </div>

                <!-- Danh sách -->
                <div class="course_box_mobile">
                    <div class="box-1" @click="activeRow(item1.currentID)" v-for="(item1, index1) in item.list" :key="index1">
                        <!-- Tiêu đề -->
                        <div class="title_course_box" :class="{'turn-arrow': activeID == item1.currentID}">
                            <div class="num_order">
                                {{ index1 + 1 }}
                            </div>
                            <div class="title_course">
                                {{ item1.examDate }}
                            </div>
                        </div>

                        <!-- Content -->
                        <div class="content_box" :class="{'active-content': activeID == item1.currentID}">
                            <!-- Thời gian làm bài thi -->
                            <div class="content_new">
                                <h1>{{ $t("scoreStaticNew.timeExamStart") }}:</h1>
                                <span>{{ item1.timeExamStart }}</span>
                            </div>

                            <!-- Thời gian kêt thúc làm bài thi -->
                            <div class="content_new">
                                <h1>{{ $t("scoreStaticNew.timeExamEnd") }}:</h1>
                                <span>{{ item1.timeExamEnd }}</span>
                            </div>

                            <!-- Số phút làm bài thi -->
                            <div class="content_new">
                                <h1>{{ $t("scoreStaticNew.timeExamConductedNew") }}:</h1>
                                <span>{{ item1.timeExamConduct }} {{$t('manage_student.minute')}}</span>
                            </div>

                            <!-- Điểm cao nhất -->
                            <div class="content_new">
                                <h1>{{ $t("new.title24") }}:</h1>
                                <span v-if="item1.score == null">-</span>
                                <span v-if="item1.score != null">{{ item1.fullMarks }}</span>
                            </div>

                            <!-- Điểm đậu -->
                            <div class="content_new">
                                <h1>{{ $t("scoreStatistics.passPercent") }}:</h1>
                                <span v-if="item1.score == null">-</span>
                                <span v-if="item1.score != null">{{ item1.checkPassMark }}</span>
                            </div>

                            <!-- Điểm đạt được -->
                            <div class="content_new">
                                <h1>{{ $t("examResume.point") }}:</h1>
                                <span v-if="item1.score == null">-</span>
                                <span>{{ item1.score }}</span>
                            </div>

                            <!-- Trạng thái -->
                            <div class="content_new">
                                <h1>{{ $t("scoreStatistics.judge") }}:</h1>
                                <span v-if="item1.score == null">-</span>
                                <span v-if="item1.score != null && Number(item1.score) >= Number(item1.passPercentScore)">
                                    {{ $t("scoreStatistics.point90") }}
                                </span>
                                <span v-if="item1.score != null && Number(item1.score) < Number(item1.passPercentScore)">
                                    {{ $t("scoreStatistics.point80") }}
                                </span>
                            </div>
                            <div class="content_new">
                                <h1>{{ $t("scoreNew.title10") }}:</h1>
                                <span><a class="btn_show_details_exam" @click="showDetailsExam(item1)" >{{$t('courseProgress.look')}}</a></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <!-- The Modal -->
        <div v-if="showDialog" id="myModal" class="modal" :class="{modal_MB:mobile}">
            <!-- Modal content -->
            <div class="modal-content">
                <div class="modal_header">
                    <span class="modal_header_name_exam">
                        <template v-if="dataDetailsClick.examName=='-'">
                            {{ $t("scoreStatistics.finalExam") }}
                        </template>
                        <template v-else>
                            {{dataDetailsClick.examName}}
                        </template>
                    </span>
                    <span class="closeModal" v-on:click="closeModal()">
                        <div class="img_exit_login">
                            <img src="../../../../static/images/wrong-while_hover.png" />
                        </div>
                    </span>
                </div>
                <div class="modal_body">
                    <!-- Hiển thị PC -->
                    <div class="modal_body_exam_pc">
                        <div class="modal_body_exam">
                            <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("new.title24") }}: </span>{{dataDetailsClick.fullMarks}} {{ $t("scoreStatistics.message2") }}</span>
                            <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("scoreStatistics.passPercent") }}: </span>{{dataDetailsClick.checkPassMark}} {{ $t("scoreStatistics.message2") }}</span>
                        </div>
                        <div class="modal_body_exam">
                            <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("examResume.point") }}: </span>{{dataDetailsClick.score}} {{ $t("scoreStatistics.message2") }}</span>
                            <span class="modal_body_exam_title">
                                <span class="modal_body_exam_title_tl">{{ $t("scoreStatistics.result") }}: </span>
                                <template v-if="dataDetailsClick.score != null &&Number(dataDetailsClick.score) >= Number(dataDetailsClick.checkPassMark)">{{ $t("scoreStatistics.point90") }}</template>
                                <template v-if="dataDetailsClick.score != null &&Number(dataDetailsClick.score) < Number(dataDetailsClick.checkPassMark)">{{ $t("scoreStatistics.point80") }}</template>
                            </span>
                        </div>
                        <div class="modal_body_exam">
                            <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("examResume.time") }}: </span>{{dataDetailsClick.examDate}}</span>
                            <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("scoreStaticNew.timeExamConductedNew") }}: </span>{{dataDetailsClick.timeExamConduct}} {{ $t("manage_student.minute") }}</span>
                        </div>
                    </div>
                    <!-- Hiển thị MB -->
                    <div class="modal_body_exam_mb">
                        <div class="modal_body_exam">
                            <span class="modal_body_exam_title">
                                <span class="modal_body_exam_title_tl">{{ $t("new.title24") }}: </span>
                                <span class="modal_body_exam_title_ct">{{dataDetailsClick.fullMarks}} {{ $t("scoreStatistics.message2") }}</span>
                            </span>
                        </div>
                        <div class="modal_body_exam">
                            <span class="modal_body_exam_title">
                                <span class="modal_body_exam_title_tl">{{ $t("scoreStatistics.passPercent") }}: </span>
                                <span class="modal_body_exam_title_ct">{{dataDetailsClick.checkPassMark}} {{ $t("scoreStatistics.message2") }}</span>
                            </span>
                        </div>
                        <div class="modal_body_exam">
                            <span class="modal_body_exam_title">
                                <span class="modal_body_exam_title_tl">{{ $t("examResume.point") }}: </span>
                                <span class="modal_body_exam_title_ct">{{dataDetailsClick.score}} {{ $t("scoreStatistics.message2") }}</span>
                            </span>
                        </div>
                        <div class="modal_body_exam">
                            <span class="modal_body_exam_title">
                                <span class="modal_body_exam_title_tl">{{ $t("scoreStatistics.result") }}: </span>
                                <span class="modal_body_exam_title_ct">
                                    <template v-if="dataDetailsClick.score != null &&Number(dataDetailsClick.score) >= Number(dataDetailsClick.checkPassMark)">{{ $t("scoreStatistics.point90") }}</template>
                                    <template v-if="dataDetailsClick.score != null &&Number(dataDetailsClick.score) < Number(dataDetailsClick.checkPassMark)">{{ $t("scoreStatistics.point80") }}</template>
                                </span>
                            </span>
                        </div>
                        <div class="modal_body_exam">
                            <span class="modal_body_exam_title">
                                <span class="modal_body_exam_title_tl">{{ $t("examResume.time") }}: </span>
                                <span class="modal_body_exam_title_ct">{{dataDetailsClick.examDate}}</span>
                            </span>
                        </div>
                        <div class="modal_body_exam">
                            <span class="modal_body_exam_title">
                                <span class="modal_body_exam_title_tl">{{ $t("scoreStaticNew.timeExamConductedNew") }}: </span>
                                <span class="modal_body_exam_title_ct">{{dataDetailsClick.timeExamConduct}} {{ $t("manage_student.minute") }}</span>
                            </span>
                        </div>
                    </div>
                    <!-- Hiển thị menu mục lục -->
                    <div class="modal_body_currilumn">
                        <span class="modal_body_currilumn_header">{{ $t("scoreNew.title1") }}</span>
                    </div>
                    <chartDetailExam
                        :data="{
                            recordId  : this.recordId,
                            studentId : this.data.studentId,
                            courseId  : this.data.courseId,
                            examId    : this.examId
                        }"
                    />
                </div>
            </div>
        </div>
        <loading class="loading--lesson" :showLoading="!isLoadData" />
    </div>
</template>

<script>
    import loading from "@/components/loading/loading";
    import { mapState, mapMutations } from "vuex";
    import chartDetailExam from "@/components/exam/chartDetailExam";

    export default {
        props: {
            data: {
                type: Object,
                default: {},
            },
        },
        data() {
            return {
                results: [],
                first: true,
                activeID: null,
                showDialog: false,
                dataDetailsClick: null,
                listDataDetailsShowDialog: [],
                isLoadData: true,
                recordId: null,
                examId: null
            };
        },
        components: {
            loading,
            chartDetailExam,
        },
        created() {
            this.init({ courseId: this.data.courseId, studentId: this.data.studentId });
        },
        computed: {
            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile,
            }),
        },
        methods: {
            init: async function (param) {
                const self = this;

                // Lấy số kì thi của khóa học
                let result = await this.getsingleCourseScoreStatistics(param);
                var listScoreStatic = [];
                result.forEach((value) => {
                    if (value.examId != null && value.examName == null) {
                        return;
                    } else {
                        listScoreStatic.push(value);
                    }
                });
                Promise.all(
                    listScoreStatic.map((item) => {
                        return self.getExamRecord(item);
                    })
                ).then(function (results) {
                    self.results = results;
                    self.first = false;
                });
            },

            // Toogle item in mobile
            activeRow: function (activeID) {
                if (this.activeID == activeID && this.activeID != null) {
                    this.activeID = null;
                } else {
                    this.activeID = activeID;
                }
            },

            makeid: function (length) {
                var result = "";
                var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
                var charactersLength = characters.length;
                for (var i = 0; i < length; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                }
                return result;
            },

            // Lấy tiến độ của khóa học
            getExamRecord: function (data) {
                const self = this;
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/home/getExamRecord", {
                            userId: data.studentId,
                            courseId: data.courseId,
                            examId: data.examId,
                            languageType: this.$lang(),
                        })
                        .then((response) => {
                            const courses = response.data.list.reduce((accumulator, value) => {
                                value["courseId"]         = data.courseId;
                                value["studentId"]        = data.studentId;
                                value["examId"]           = data.examId;
                                value["passPercentScore"] = (parseInt(value.fullMarks) / 100) * data.passPercent;
                                value["checkPassMark"]    = (parseInt(value.fullMarks) / 100) * data.passPercent;
                                value["fullMarksScore"]   = parseInt(value.fullMarks);
                                value["currentID"]        = self.makeid(5);
                                accumulator.push(value);
                                return accumulator;
                            }, []);
                            data["list"] = courses;
                            resolve(data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Lấy số kì thi trong khóa học
            getsingleCourseScoreStatistics: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/home/getsingleCourseScoreStatistics", {
                            userId: data.studentId,
                            courseId: data.courseId,
                            languageType: this.$lang(),
                        })
                        .then((response) => {
                            const courses = response.data.reduce((accumulator, value) => {
                                let obj = {
                                    courseId: data.courseId,
                                    studentId: data.studentId,
                                    examId: value.examId,
                                    passPercent: value.passPercent,
                                    examName: value.examName,
                                };
                                obj.courseId = value.examId != null ? null : obj.courseId;
                                accumulator.push(obj);
                                return accumulator;
                            }, []);
                            resolve(courses);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },
            /// Dialog hiển thị thông tin chi tiết thi
            showDetailsExam(params) {
                this.isLoadData       = false;
                this.dataDetailsClick = params;
                this.recordId         = params.id;
                this.examId           = params.examId || null;
                this.isLoadData       = true;
                this.showDialog       = true;
            },
            closeModal() {
                this.showDialog = false;
            },
            // vuex
            ...mapMutations("manageDetail", []),
        },
    };
</script>

<style scoped>
    .nqtLearnPercent {
        margin-bottom: 15px;
    }
    .exam_begins_box {
        margin-top: 10px !important;
    }
    .nameTestExam {
        padding-left: 5px;
    }
    /* Hiển thị modal */
    .btn_show_details_exam {
        background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
        padding: 3px 8px;
        border-radius: 15px;
        -webkit-transition: 0.5s ease;
        transition: 0.5s ease;
        color: #fff;
    }
    .modal {
        position: fixed; /* Stay in place */
        z-index: 1000001; /* Sit on top */
        padding-top: 100px; /* Location of the box */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0, 0, 0); /* Fallback color */
        background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
    }
    /* Modal Content */
    .modal-content {
        background-color: #fefefe;
        /* background-image: linear-gradient(0deg, #d5f1ff 0%, #53e0fd 100%); */
        margin: auto;
        padding: 0px 10px;
        border: 1px solid #888;
        width: 50%;
        border-radius: 10px;
        min-height: 100px;
    }
    .img_exit_login {
        float: right;
        margin-right: 0px;
        margin-top: 0px;
        padding: 0px;
        cursor: pointer;
    }
    .modal_header_name_exam {
        font-weight: bold;
        font-size: 18px;
    }
    .modal_header {
        padding-top: 5px;
    }
    .modal_body {
        padding-top: 20px;
    }
    .modal_body_exam {
        border-bottom: 1px solid #e2dfdf;
        display: flex;
    }
    .modal_body_exam .modal_body_exam_title {
        font-size: 13px;
        width: 50%;
        padding-top: 1vh;
    }
    .modal_body_exam_title_tl {
        font-weight: bold;
    }
    .modal_body_currilumn {
        padding-top: 2vh;
        padding-bottom: 2vh;
    }
    .modal_body_currilumn_header {
        font-size: 14px;
        font-weight: bold;
    }
    .modal_body_currilumn_header_hd {
        display: flex;
        padding: 1vh 0vh;
        font-size: 13px;
    }
    .modal_body_currilumn_header_hd span {
        font-weight: bold;
    }
    .modal_body_currilumn_header_bd {
        padding: 1vh 0vh;
        display: flex;
        font-size: 13px;
    }
    .tnv_ct {
        width: 60%;
    }
    .tnv_as {
        width: 20%;
        text-align: center;
    }
    .tnv_score {
        width: 20%;
        text-align: center;
    }
    .btn-download-tt {
        height: 40px;
        border: 2px solid #0071c5;
        background-color: #ffffff;
        color: black;
        font-size: 12px;
        font-weight: bold;
        border-radius: 5px;
        margin-top: 5px;
        margin-bottom: 0;
        transition: ease 0.5s;
        width: 140px;
        position: relative;
    }
    /* MB */
    .content_new .btn_show_details_exam {
        background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
        padding: 3px 8px;
        border-radius: 15px;
        -webkit-transition: 0.5s ease;
        transition: 0.5s ease;
        color: #fff;
    }
    .modal_MB .modal-content {
        width: 90% !important;
    }
    .modal_body_exam_mb {
        display: none;
    }
    @media (max-width: 480px) {
        .modal_body_exam_mb {
            display: unset;
        }
        .modal_body_exam_mb .modal_body_exam_title {
            width: 100%;
        }
        .modal_body_exam_pc {
            display: none;
        }
        .modal_body_exam_title_ct {
            float: right;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/manage/detail/historyExamMobile.vue